import React from 'react';
import Header from '../../Header';
import Footer from '../../Footer';
import ThreeLensHero from './ThreeLensHero';
import MainContent from './MainContent';
import Lens1 from './Lens1';
import Lens2 from './Lens2';
import Lens3 from './Lens3';
import FundSelect from './FundSelect';
import OtherFilters from './OtherFilters';
import ThreeLensFAQ from './ThreeLensFAQ';

const ThreeLens = () => {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <ThreeLensHero />
          <MainContent/>
          <Lens1/>
          <Lens2/>
          <Lens3/>
          <FundSelect/>
          <OtherFilters/>
          <ThreeLensFAQ/>
        </main>
        <Footer />
      </div>
    );
  };



  export default ThreeLens;